import _prop from "ramda/src/prop";
import _ifElse from "ramda/src/ifElse";
import _toUpper from "ramda/src/toUpper";
import _evolve from "ramda/src/evolve";
import _omit from "ramda/src/omit";
import _pipe from "ramda/src/pipe";
import _applyTo from "ramda/src/applyTo";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _asyncToGenerator from "@babel/runtime/helpers/asyncToGenerator";
import _always from "ramda/src/always";
import _identity from "ramda/src/identity";
import _toLower from "ramda/src/toLower";
import _regeneratorRuntime from "@babel/runtime/regenerator";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import fetchPonyfill from 'fetch-ponyfill';
import { isFunction, isTypeOf } from "../../browser/is";
import { mapKeys } from "../../browser/object";
import { withQuery, joinPathParts } from "../../browser/url";
import { normalize, serializeBody, handleError, RESPONSE } from "./lib";
var _fetchPonyfill = fetchPonyfill({}),
  isoFetch = _fetchPonyfill.fetch;
var lowerCaseKeys = mapKeys(_toLower);
export { RESPONSE };
export var fetchWith = function fetchWith() {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$url = _ref.url,
    getUrl = _ref$url === void 0 ? _identity : _ref$url,
    _ref$headers = _ref.headers,
    getHeaders = _ref$headers === void 0 ? _always({}) : _ref$headers,
    _ref$isJson = _ref.isJson,
    isJson = _ref$isJson === void 0 ? isTypeOf('object') : _ref$isJson,
    _ref$respondWith = _ref.respondWith,
    respondWith = _ref$respondWith === void 0 ? RESPONSE.BODY : _ref$respondWith,
    _ref$errorWith = _ref.errorWith,
    errorWith = _ref$errorWith === void 0 ? handleError : _ref$errorWith,
    _ref$fetch = _ref.fetch,
    fetch = _ref$fetch === void 0 ? isoFetch : _ref$fetch,
    _ref$query = _ref.query,
    initQuery = _ref$query === void 0 ? {} : _ref$query;
  return normalize(function () {
    var _ref2 = _asyncToGenerator(_regeneratorRuntime.mark(function _callee(config) {
      var body, _config$query, query, url, headers, urlWithQuery, contentType;
      return _regeneratorRuntime.wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            body = config.body, _config$query = config.query, query = _config$query === void 0 ? {} : _config$query;
            if (!isFunction(getUrl)) {
              _context.next = 7;
              break;
            }
            _context.next = 4;
            return getUrl(config.url);
          case 4:
            _context.t0 = _context.sent;
            _context.next = 8;
            break;
          case 7:
            _context.t0 = joinPathParts(getUrl, config.url);
          case 8:
            url = _context.t0;
            if (!isFunction(getHeaders)) {
              _context.next = 15;
              break;
            }
            _context.next = 12;
            return getHeaders();
          case 12:
            _context.t1 = _context.sent;
            _context.next = 16;
            break;
          case 15:
            _context.t1 = getHeaders;
          case 16:
            headers = _context.t1;
            urlWithQuery = withQuery(_objectSpread(_objectSpread({}, initQuery), query), url);
            _context.next = 20;
            return isJson(body);
          case 20:
            if (!_context.sent) {
              _context.next = 24;
              break;
            }
            _context.t2 = 'application/json';
            _context.next = 25;
            break;
          case 24:
            _context.t2 = 'text/plain';
          case 25:
            contentType = _context.t2;
            return _context.abrupt("return", (config.fetch || fetch)(urlWithQuery, _objectSpread(_objectSpread({}, _applyTo(config, _pipe(_omit(['query', 'fetch', 'respondWith', 'errorWith', 'url', 'pathname']), _evolve({
              method: _toUpper
            })))), {}, {
              url: urlWithQuery,
              body: serializeBody(contentType, body),
              headers: _objectSpread(_objectSpread({
                'content-type': contentType
              }, lowerCaseKeys(headers)), lowerCaseKeys(config.headers))
            })).then(_ifElse(_prop('ok'), config.respondWith || respondWith, config.errorWith || errorWith)));
          case 27:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function (_x) {
      return _ref2.apply(this, arguments);
    };
  }());
};
export default fetchWith();